// @ts-nocheck
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface LinkBackPresentationProps extends ExpandStyles<LinkBackStyles> {}

export interface LinkBackProps extends LinkBackPresentationProps {
    pageLink?: PageLinkModel;
    onClick?: () => void;
    // Store Custom Code
    pageIdSegment?: string;
    isV2?: boolean;
}

export interface LinkBackStyles {
    link?: LinkPresentationProps;
}

export const linkBackStyles: LinkBackStyles = {
    link: mergeProps<LinkBackStyles["link"]>(linkGetActionLinkProps(ArrowBackward), {
        css: css`
            ${breakpointValues(pxToRemArray([16, null, 20, null, 24]), "margin-bottom")}

            @media print {
                display: none;
            }
        `,
    }),
};

/* Store Custom Code - Start */
export const linkBackStylesV2: LinkBackStyles = {
    link: mergeProps<LinkBackStyles["link"]>(linkGetActionLinkProps(ArrowBackward), {
        css: css`
            ${breakpointValues(pxToRemArray([32]), "margin-bottom")}

            @media print {
                display: none;
            }
        `,
    }),
};
/* Store Custom Code - End */

const LinkBack: FC<LinkBackProps> = ({
    extendedStyles,
    overridedStyles,
    pageLink,
    onClick,
    // Store Custom Code
    pageIdSegment = "",
    isV2,
}) => {
    const styles = useExpandProps(isV2 ? linkBackStylesV2 : linkBackStyles, extendedStyles, overridedStyles); // Store Custom Code

    if (!pageLink?.url && !onClick) {
        return null;
    }

    /* Store Custom Code - Start */
    const href = !onClick && pageLink?.url ? `${pageLink.url}${pageIdSegment}` : undefined;
    /* Store Custom Code - End */

    return (
        <Link
            {...styles.link}
            href={href} // Store Custom Code
            onClick={onClick}
            // Store Custom Code
            data-test-selector="linkBack"
        >
            {pageLink?.title ? translate("Back to {0}", pageLink.title) : translate("Back")}
        </Link>
    );
};

export default LinkBack;
